<template>
  <div class="quick-menu-container is-lms">
    <div class="quick-menu">
      <div>
        <!-- 교직원집합연수 -->
        <div class="staff-menu">
          <div class="caption-item">
            <div class="caption__header">
              <span class="web-visible">교직원집합연수</span>
              <span class="mob-visible pointer" @click="goTraining">교직원집합연수</span>
            </div>
            <div class="caption__content">
              <ul>
                <li @click="goTraining">
                  <img src="~@/assets/images/portal/icon/main/renewal/icon_quick.png" alt="연간연수일정 화면 이동" />
                  <span>연간연수일정</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 블렌디드러닝연수시스템 -->
        <div class="contact-menu">
          <div class="caption-item">
            <div class="caption__header">
              <span class="web-visible">블렌디드러닝연수시스템</span>
              <span class="mob-visible pointer" @click="goContact">블렌디드러닝<br>연수시스템</span>
              <span class="material-icons-round web-visible" @click="goContact">add</span>
            </div>
            <div class="caption__content system">
              <!-- 로그인 하면 "change-justify-content" 비활성화 부탁드립니다.-->
              <ul :class="$validate.isEmpty(loginUser.userOid) ? 'change-justify-content' : ''">
                <li v-if="$validate.isNotEmpty(loginUser.userOid)" @click="goContactEducationLecture">
                  <img src="~@/assets/images/portal/icon/main/renewal/icon_room.png" alt="나의 연수방으로 이동"/>
                  <span>나의 연수방</span>
                </li>
                <li @click="goContactEducationApply">
                  <img class="sign" src="~@/assets/images/portal/icon/main/renewal/icon_sign.png" alt="수강신청으로 이동"/>
                  <span>수강신청</span>
                </li>
                <li @click="goContactEducationTrainPlan">
                  <img src="~@/assets/images/portal/icon/main/renewal/icon_plan.png" alt="연수운영계획"/>
                  <span>연수운영계획</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 원격교육연수 -->
        <div class="ontact-menu">
          <div class="caption-item">
            <div class="caption__header">
              <span class="web-visible">원격교육연수</span>
              <span class="mob-visible pointer" @click="goOntact">원격교육연수</span>
              <span class="material-icons-round web-visible" @click="goOntact">add</span>
            </div>
            <div class="caption__content">
              <ul>
                <li v-if="$validate.isNotEmpty(loginUser.userOid)" @click="goOntactEduLecture">
                  <img src="~@/assets/images/portal/icon/main/renewal/icon_room.png" alt="나의 연수방으로 이동"/>
                  <span>나의 연수방</span>
                </li>
                <li @click="goOntactEduJopApply">
                  <img class="duty" src="~@/assets/images/portal/icon/main/renewal/icon_duty.png" alt="직무연수 수강으로 이동"/>
                  <span>직무연수 수강</span>
                </li>
                <li @click="goOntactEduFreeApply">
                  <div class="quick-icon-box autonomy"></div>
                  <img src="~@/assets/images/portal/icon/main/renewal/icon_autonomy.png" alt="자율연수 수강으로 이동" />
                  <span>자율연수 수강</span>
                </li>
                <li v-if="$validate.isEmpty(loginUser.userOid)" @click="goOntactEducationTrainPlan">
                  <div class="quick-icon-box plan"></div>
                  <img src="~@/assets/images/portal/icon/main/renewal/icon_quick.png" alt="연간연수일정 화면 이동" />
                  <span>연간연수일정</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div>
        <!-- 과학정보교육 -->
        <div class="science-menu">
          <div class="caption-item">
            <div class="caption__header">
              <span class="web-visible">과학정보교육</span>
              <span class="mob-visible pointer" @click="goToScienceEdu">과학정보교육</span>
            </div>
            <div class="caption__content">
              <ul>
                <li @click="goToScienceEdu">
                  <img src="~@/assets/images/portal/icon/main/renewal/icon_science.png" alt="과학교육으로 이동"/>
                  <span>과학교육</span>
                </li>
                <li @click="goToInfomationEdu">
                  <img src="~@/assets/images/portal/icon/main/renewal/icon_info.png" alt="정보교육으로 이동"/>
                  <div class="quick-icon-box info"></div>
                  <span>정보교육</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 정보영재교육 -->
        <div class="information-menu">
          <div class="caption-item">
            <div class="caption__header">
              <span class="web-visible">정보영재교육</span>
              <span class="mob-visible pointer" @click="goToCenterGenius">정보영재교육</span>
            </div>
            <div class="caption__content">
              <ul>
                <li @click="goToCenterGenius">
                  <img src="~@/assets/images/portal/icon/main/renewal/icon_genius.png" alt="정보영재교육원으로 이동"/>
                  <div class="quick-icon-box genius"></div>
                  <span>정보영재교육원</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 교육서비스 -->
        <div class="service-menu">
          <div class="caption-item">
            <div class="caption__header">
              <span class="web-visible">교육서비스</span>
              <span class="mob-visible pointer" @click="goToElearning">교육서비스</span>
            </div>
            <div class="caption__content">
              <ul>
                <li @click="goToElearning">
                  <img class="e-learning" src="~@/assets/images/portal/icon/main/renewal/icon_eLearning.png" alt="e학습터로 이동"/>
                  <span><em>e</em> 학습터</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

const URL_LMS = process.env.SYSTEM.LMS.URL;

export default {
  data() {
    return {}
  },
  computed: {

    ...mapGetters( {
      loginUser: "common/login/loginUserInfo",
    } ),
  },
  methods: {

    // 블렌디드 - 나의 강의실
    goContactEducationLecture() {
      window.open( URL_LMS + "/lms/sso/sso_loginWithType?type=E" )
    },
    // 블렌디드 - 수강 신청
    goContactEducationApply() {
      window.open( URL_LMS + "/lms/sso/sso_loginWithType?type=F" )
    },
    // 블렌디드 - 연수운영계획
    goContactEducationTrainPlan() {
      window.open( URL_LMS + "/lms/sso/sso_loginWithType?type=G" )
    },
    // 블렌디드 바로가기
    goContact() {
      window.open( URL_LMS + "/lms/sso/sso_loginWithType?type=CM" )
    },

    // 원격교육연수 - 연간연수일정
    goOntactEducationTrainPlan() {
      window.open( URL_LMS + "/lms/sso/sso_loginWithType?type=D" )
    },
    // 원격교육연수 - 나의 강의실
    goOntactEduLecture() {
      window.open( URL_LMS + "/lms/sso/sso_loginWithType?type=A" )
    },
    // 원격교육연수 - 직무연수 수강신청
    goOntactEduJopApply() {
      window.open( URL_LMS + "/lms/sso/sso_loginWithType?type=B" )
    },
    // 원격교육연수 - 자율연수 수강신청
    goOntactEduFreeApply() {
      window.open( URL_LMS + "/lms/sso/sso_loginWithType?type=C" )
    },
    // 원격교육연수 바로가기
    goOntact() {
      window.open( URL_LMS + "/lms/sso/sso_loginWithType?type=OM" )
    },

    goToScienceEdu() {
      const query = {
        menuOid: this.$constant.MENU_OID.SCIENCE_EXHIBITION, // 과학전람회로 포커싱
        boardOid: this.$constant.MENU_OID.SCIENCE_EXHIBITION,
        menuTypeFlag: this.$constant.MENU_TYPE_FLAG.MIX.KEY,
      }

      this.$router.push( {
        path: '/portal/user/common/commonForm',
        query,
      } );

    },

    goToInfomationEdu() {

      const query = {
        menuOid: this.$constant.MENU_OID.INFORMATION_EDU,
        boardOid: this.$constant.MENU_OID.INFORMATION_EDU,
      }

      this.$router.push( {
        path: '/portal/user/common/commonBoard_list',
        query,
      } );

    },

    goToCenterGenius() {

      this.$router.push( this.$constant.MENU_URL.CENTER_GENIUS );
    },

    goTraining() {
      this.$router.push( {path: '/portal/user/common/commonScreen?menuOid=1TRvaqvX01E',} );
    },

    goToElearning() {
      window.open( "https://cls.edunet.net/" );
    }

  },

}
</script>
<style scoped>
</style>
